export enum Direction {
  Step1 = 1,
  Step2 = 2,
  Step6 = 6,
  Step3 = 3,
  Step4 = 4,
  Step5 = 5,
}
